import React from 'react'
import { bem } from '@argos/utils'

const cn = bem({ prefix: 'lc-', block: 'message-image-file-transfer' })

export const MessageImageFileTransfer = ({ src, name }) => (
  <a href={src} target='_blank'>
    <img className={cn()} src={src} alt={name} />
  </a>
)

MessageImageFileTransfer.defaultProps = {
  alt: 'Agent image',
}

export default MessageImageFileTransfer
